"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var AbstractAnimationValue_1 = require("../properties/AbstractAnimationValue");
var AnimationMultidimensional = (function (_super) {
    tslib_1.__extends(AnimationMultidimensional, _super);
    function AnimationMultidimensional(rawData, version) {
        return _super.call(this, rawData, version) || this;
    }
    return AnimationMultidimensional;
}(AbstractAnimationValue_1.AbstractAnimationValue));
exports.AnimationMultidimensional = AnimationMultidimensional;
//# sourceMappingURL=AnimationMultidimensional.js.map